export default __webpack_public_path__ + "static/media/Entradas.7d918839.jpg";